import {
  ExchangeRecommendationsSchema,
  GenerateExchangeRecommendationsInputSchema,
} from "@redotech/redo-model/agents/returns-agents/exchange-recommendations";

export const getExchangeRecommendations = {
  name: "getExchangeRecommendations" as const,
  input: GenerateExchangeRecommendationsInputSchema,
  output: ExchangeRecommendationsSchema,
};
